import React from "react";
import { observer } from "mobx-react";
import { Button, TextField } from "@material-ui/core";
import { jsonParser, post } from "../../utils/Client";


class SendNotification extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      title: "",
      message : "",
      error: "",
    }
  }

  submitNotification = async () => {
    try{
      const { title, message } = this.state;
      const data = {
        title: title,
        description: message,
      };
      await post("/users/send-notification", { body: data }).then(jsonParser);
      this.setState({ title: "", message: "", error: "", submitting: false });
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao enviar a notificação", submitting: false });
    }
  }

  render() {
    const { message, submitting, error, title } = this.state;

    return (
      <div className="holder" style={styles.container}>
        <h4>
          Envie uma notificação para as vendedoras
        </h4>

        <div style={{ paddingLeft: 20, paddingRight: 30 }}>
          <TextField
            value={title}
            label="Digite o título"
            variant="outlined"
            multiline={true}
            onChange={(e) => this.setState({ title: e.target.value.substring(0, 80) })}
            fullWidth
            helperText={`${title.length}/80`}
          />

          <TextField
            value={message}
            label="Digite a mensagem"
            variant="outlined"
            multiline={true}
            rows={5}
            onChange={(e) => this.setState({ message: e.target.value.substring(0, 600) })}
            fullWidth
            helperText={`${message.length}/600`}
          />
          { (!!error) &&
            <div style={{ color: "#FF0000", fontSize: 12, width: "100%", textAlign: "left", marginBottom: 20 }}>
              {error}
            </div>
          }

          <Button 
            onClick={() => this.setState({ submitting: true }, this.submitNotification)}
            disabled={submitting || !message || !title}
            size="medium"
            variant="outlined"
            color="default"
          >
            Enviar
          </Button>
        </div>
      </div>
    );
  }
}

export default observer(SendNotification);

const styles = {
  container               : {
    paddingLeft               : 10,
    paddingTop                : 10,
    width                     : "80%",
  },
  subHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
  panelsStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
};